import { Languages } from "../Enums/companyStatus";

const FLAG_PATHS: Record<number, string> = {
  [Languages.ENGLISH]: "/united-kingdom.png",
  [Languages.GERMAN]: "/germany.png",
  [Languages.SERBIAN]: "/serbian-flag.png",
};

export const getFlagPath = (languageId: number): string | undefined => {
  return FLAG_PATHS[languageId];
};
